import { jsx } from "react/jsx-runtime";
import { createContext, useState, useContext } from "react";
import { useEvent } from "../../../../lib/hooks/useEvent.js";
const IsVideoPausedContext = createContext(false);
IsVideoPausedContext.displayName = "IsVideoPausedContext";
function useIsVideoPaused() {
  const isVideoPaused = useContext(IsVideoPausedContext);
  if (isVideoPaused == null) {
    throw new Error("useIsVideoPaused called without a IsVideoPausedContext.Provider");
  }
  return isVideoPaused;
}
const SetIsVideoPausedContext = createContext(
  /** @type {((paused: boolean) => void) | undefined} */
  void 0
);
SetIsVideoPausedContext.displayName = "SetIsVideoPausedContext";
function useSetIsVideoPaused() {
  const setIsVideoPaused = useContext(SetIsVideoPausedContext);
  if (!setIsVideoPaused) {
    throw new Error("useSetIsVideoPaused called without a SetIsVideoPausedContext.Provider");
  }
  return setIsVideoPaused;
}
function VideoIsPausedProvider({ children, onPlay, onPause }) {
  const [isPaused, setIsPaused] = useState(true);
  const handlePlayPause = useEvent((paused) => {
    var _a;
    setIsPaused(paused);
    (_a = paused ? onPause : onPlay) == null ? void 0 : _a();
  });
  return /* @__PURE__ */jsx(SetIsVideoPausedContext.Provider, { value: handlePlayPause, children: /* @__PURE__ */jsx(IsVideoPausedContext.Provider, { value: isPaused, children }) });
}
export {
  IsVideoPausedContext,
  SetIsVideoPausedContext,
  VideoIsPausedProvider,
  useIsVideoPaused,
  useSetIsVideoPaused };
//# sourceMappingURL=dist/components/VideoContextProvider/context/state/isPaused.js.map